// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_LICENSE_ITEM = 'solusvm-license/SET_LICENSE_ITEM';
export const SET_COMPUTE_RESOURCES = 'solusvm-license/SET_COMPUTE_RESOURCES';
